import React from "react";
import { Link } from "react-router-dom";
import { Media } from "reactstrap";
import { ACCOUNT_HOME } from "../account/accountNavItems";

/*
    The user icon in the header.

    It used to open a dropdown holding "Settings" and "Logout". Both of those
    now live in the account navigation itself, so the dropdown was a menu with
    nothing left in it that the destination does not already show. The icon is
    now simply the way in: one click to My Details, instead of a click to open
    a menu and a second to choose the only useful item in it.
*/
const UserProfileLink = () => (
  <Link
    to={ACCOUNT_HOME}
    className="nav-link pr-0"
    aria-label="Your account settings"
  >
    <Media className="align-items-center">
      <img
        height={30}
        width={30}
        className="rounded-circle"
        alt=""
        src="https://i.imgur.com/b08hxPY.png"
      />
    </Media>
  </Link>
);

export default UserProfileLink;
